import {isEmpty, sortBy, cloneDeep} from 'lodash'
import constants from '@/libs/constant/constants'
import {message, errorHandler, logout, loader, openTermAndPrivacy} from '@/libs/helper'
import { getAllFollowingList, checkForAdminAccess, API_BASE_URL, createScreenName, validateScreenName, validatePublicationUrl, searchMeta } from '@/libs/api/api'
import ClaimedMessage from '../../../../component/ClaimedMessage/ClaimedMessage.vue'

export default{
    name: 'SearchAuthor',
    props: {
        stepForward: {
            type: Function,
            default: ()=> {}
        },
        setClaimTo: {
            type: Function,
            default: ()=> {}
        },
        cancel: {
            type: Function,
            default: ()=> {}
        },
        claimTo: {
            type: Object,
            default: () => {}
        },
        module: {
            type: String,
            default: () => constants.AUTHOR.key
        },
        isAdmin: {
            type: Boolean,
            default: false
        },
        organisation: {
            type: Boolean,
            default: false
        }
    },
    components: {
        ClaimedMessage
    },
    beforeMount(){
        this.authorToAdd = this.claimTo
        this.screen = this.claimTo
    },
    watch: {
        claimTo (newValue) {
            this.urls = newValue.url || []
            this.screen = newValue
        }
    },
    data(){
        return {
            isEmpty,
            termsAndPolicy: false,
            authorToAdd: {
                name: ''
            },
            showClaimedMessage: false,
            isScreenName: false,
            email: {},
            urlToAdd: {url: ''},
            urls: this.claimTo.url || [],
            domain: 'domain',
            screen: {
                screen_name: this.claimTo.screen_name || ''
            },
            validateSlug: function (rule, value, callback) {
                /* eslint-disable */
                let regex = /[!@#$%^&*()_+\=\[\]{};':"\\|,.<>\/?]+/
                let checkSpaces = /\s/g
                if (this.isAdmin) {
                    if (!isEmpty(value) && (value.length > 20)) callback(new Error(('Invalid screen name')))
                    if (!isEmpty(value) && regex.test(value)) callback(new Error('Invalid screen name'))
                    if (!isEmpty(value) && checkSpaces.test(value)) callback(new Error('Spaces are not allowed'))
                    else callback()
                } else {
                    if (isEmpty(value) || (value && value.length > 20)) callback(new Error(window.i18next.t('Invalid screen name')))
                    if (regex.test(value)) callback(new Error(window.i18next.t('Invalid screen name')))
                    if (checkSpaces.test(value)) callback(new Error(window.i18next.t('Spaces are not allowed')))
                    else callback()
                }
            },
            /**
             * regex for url section of publication
             */
            validateUrl: function (rule, value, callback) {
                let regex = /^[a-zA-Z0-9][a-zA-Z0-9-]{1,61}[a-zA-Z0-9]\.[a-zA-Z]{2,}$/
                // if (isEmpty(value)) callback(new Error('Invalid Url'))
                if (!regex.test(value)) callback(new Error(window.i18next.t('Invalid Url')))
                else callback()
            },
        }
    },
    methods: {
        querySearch: async function(queryString, cb) {
            if(isEmpty(queryString) || queryString.split('').length < 2){
                return
            }

            let searchResult = []
            if (this.organisation) {
                let body = {
                    entity_type: this.module,
                    search_text: queryString
                }
                try{
                    searchResult = await searchMeta(body)
                    cb(searchResult.items[this.module])
                    return
                }catch(error){
                    return error
                }
            }
            let body = {
                search_name: queryString,
                is_global: true
            }

            try{
                searchResult = await this.searchFollowers(body, this.module.toLowerCase())
            }catch(error){
                return error
            }

            let listToDisplay = sortBy(searchResult[this.module], 'name') || []

            listToDisplay.unshift({
                name: queryString,
                last_name: queryString,
                subtitle: `${window.i18next.t(`Register an ${this.module.toLowerCase()} with the name`)} “${queryString}”`,
                hideImage: true,
                isNew: true
            })

            // call callback function to return suggestion objects
            cb(listToDisplay);
        },
        createFilter(queryString) {
            return (link) => {
                return (link.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
            };
        },
        /**
         * API call to fetch theauthor, publication, publisher by text/string.
         * @params {object} body to send in the API call
         * @params {object} params to add with the API URL
         */
        searchFollowers (body, params) {
            return getAllFollowingList(body, params).then((response) => {
                return response.items
            }).catch((error) => {
                return error
            })
        },
        handleSelect(selectedAuthor){
            // create the screen name(slug)
            this.createSlug(selectedAuthor)
            // same screen is used on admin portal(isAdmin = true)
            if (this.isAdmin) {
                if (selectedAuthor.subtitle) {
                    this.authorToAdd = selectedAuthor
                    this.setClaimTo(selectedAuthor)
                } else {
                    this.$router.push({name: 'editPublishers', params: {id: selectedAuthor._id}})
                }
            } else {
                this.authorToAdd = selectedAuthor
                this.setClaimTo(selectedAuthor)
            }
            
        },
        checkNext: async function () {
            if(this.organisation) {
                this.stepForward()
            }
            if(this.authorToAdd.is_admin){
                this.name = this.authorToAdd.name
                this.email = this.$store.getters.getUserInformation.email
                this.showClaimedMessage = true
                return
            }

            if(this.authorToAdd.isNew){
                let claimTo = this.claimTo
                this.$refs['screen-name-form'].validate(async(valid) => {
                    if(!valid){
                        return
                    }
                    loader(this, true)
                    let response = await this.validateMetaScreenName()
                if (response) {
                    this.stepForward()
                    claimTo.screen_name = this.screen.screen_name
                } else {
                    message(this, constants.messageType.ERROR, 'Screen name is not valid')
                }
                loader(this, false)
                })
                
                return
            }
            
            loader(this, true);
            let body = {
                type: this.module,
                id: this.authorToAdd._id || this.claimTo._id

            }
            checkForAdminAccess(body)
                .then((response)=>{
                    if(response.is_claimed){
                        this.name = this.authorToAdd.name
                        this.email = response.email
                        this.showClaimedMessage = true
                    } else {
                        this.setClaimTo(this.authorToAdd)
                        this.stepForward()
                    }
                    loader(this, false);
                })
                .catch((error)=>{
                    loader(this, false);
                    message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
                })
        },
        getURL(imageName){
            return `${API_BASE_URL}/accounts/files/${imageName}?auth=${localStorage.getItem('accuraAuthToken')}`
        },
        /*
         * return the place holder image in case of error in image loading.
         * */
        onError(e) {
            let avatarURL = require('../../../../../assets/images/author_placeholder.png');
            if (e.target.src !== avatarURL) {
                e.target.src = avatarURL;
            }
        },
        toggleClaimMessage(){
            this.showClaimedMessage = !this.showClaimedMessage
        },
        isDisabled(){
            if (this.isAdmin && this.authorToAdd.name !== undefined && this.authorToAdd.name !== '' && this.screen.screen_name !== undefined && this.screen.screen_name !== '') return false
            if(this.termsAndPolicy === true && this.authorToAdd.name !== undefined && this.authorToAdd.name !== '' && ((this.screen.screen_name !== undefined && this.screen.screen_name !== '') || this.isScreenName)){
                return false
            }
            return true
        },
        getHeader(module){
            switch (module){
                case constants.AUTHOR.key:
                    return 'What is the name of the Author'
                case constants.PUBLISHER.key:
                    return 'What is the name of the Publisher'
                case constants.PUBLICATION.key:
                    return 'What is the name of the Publication'
            }
        },
        getSubHeader(module){
            switch (module){
                case constants.AUTHOR.key:
                    return 'Maintain the information of an author'
                case constants.PUBLISHER.key:
                    return 'Maintain the information of a Publisher'
                case constants.PUBLICATION.key:
                    return 'Maintain the information of a Publication'
            }
        },
        getSearchInputLabel(module){
            switch (module){
                case constants.AUTHOR.key:
                    return 'Author Name'
                case constants.PUBLISHER.key:
                    return 'Publisher Name'
                case constants.PUBLICATION.key:
                    return 'Publication Name'
            }
        },
        getInputPlaceHolder(module){
            switch (module){
                case constants.AUTHOR.key:
                    return 'Search or add new author'
                case constants.PUBLISHER.key:
                    return 'Search or add new publisher'
                case constants.PUBLICATION.key:
                    return 'Search or add new publication'
            }
        },
        getCheckboxLabel(module){
            switch (module){
                case constants.AUTHOR.key:
                    return 'By registering an Author, you agree to the following'
                case constants.PUBLISHER.key:
                    return 'By registering an publisher, you agree to the following'
                case constants.PUBLICATION.key:
                    return 'By registering an publication, you agree to the following'
            }
        },
        openPage(page){
            openTermAndPrivacy(page)
        },

        

        /**
         * adding url to the fields
         */
        addUrl (formName, item) {
            this.$refs[formName].validate(async (valid) => {
                if ((!valid) || (new Set(this.urls).has(item))) return 
                loader(this, true)
                let isValid = await this.checkPublicationUrl([item])
                if (isValid) {
                    let url = cloneDeep(this.urls)
                    url.push(item)
                    this.urls = url
                    this.urlToAdd.url = ''
                } else {
                    message(this, constants.messageType.ERROR, 'Domain is already present')
                }
                loader(this, false)
            })
        },

        /**
         * remove url form the urls
         */
        removeUrl (item) {
            let urls = cloneDeep(this.urls)
            urls = urls.filter(url => url !== item)
            this.urls = urls
        },

        /**
         * create screen name
         */
        createSlug (meta) {
            if (isEmpty(meta) || !meta.isNew) {
                this.isScreenName = true
                return
            }
            this.isScreenName = false
            // body for api
            let body = {
                entity_type: this.module,
                name: meta.name
            }
            createScreenName(body).then(response => {
                this.$set(this.screen, 'screen_name', response.response)
            }).catch(() => {})
        },
        
        /**
         * to get the description for scrren name(slug)
         */
        getSlugDescription (module) {
            switch (module) {
                case constants.AUTHOR.key:
                return 'Author screen name (max 20 characters, no spaces [A-Z, a-z, 0-9, -])'
                case constants.PUBLICATION.key:
                return 'Publication screen name (max 20 characters, no spaces [A-Z, a-z, 0-9, -])'
                case constants.PUBLISHER.key:
                return 'Publisher screen name (max 20 characters, no spaces [A-Z, a-z, 0-9, -])'
            }
        },

        /**
         * to validate screen name of 
         * A/P/P on click of next button
         */
        validateMetaScreenName: async function () {
            try {
                // body for api call
                let body = {
                    entity_type: this.module,
                    screen_name: this.screen.screen_name
                }
                // api call
                let response = await validateScreenName(body)
                let isValid = response.isUnique
                // to validate the domain url
                if (isValid && this.module === constants.PUBLICATION.key) {
                    // api call
                    let result = await validatePublicationUrl({url: this.urls})
                    isValid = result.isUnique
                    let claimTo = this.claimTo
                    claimTo.url = this.urls
                }
                return isValid
            } catch (error) {
                return error
            }
        },
        isPublicationDisabled () {
            if (this.organisation && this.claimTo.organisation_id) return true
            if(this.termsAndPolicy === true && this.authorToAdd.name !== undefined && this.authorToAdd.name !== '' && ((this.screen.screen_name !== undefined && this.screen.screen_name !== '') || this.isScreenName) && (!isEmpty(this.urls) || this.isScreenName)){
                return false
            }
            return true
        },
        checkPublicationUrl: async function (url) {
            let response = await validatePublicationUrl({url})
            return response.isUnique
        }
    }
}